import { useEffect } from 'react';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { doc, updateDoc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';
import app from '../firebase';

const VAPID_KEY = process.env.REACT_APP_FCM_VAPID_KEY;

export function useFCM() {
  useEffect(() => {
    const setupFCM = async () => {
      const user = auth.currentUser;
      if (!user) return;

      if (!('Notification' in window) || !('serviceWorker' in navigator)) return;
      if (Notification.permission === 'denied') return;

      try {
        const messaging = getMessaging(app);

        const permission = await Notification.requestPermission();
        if (permission !== 'granted') return;

        const token = await getToken(messaging, { vapidKey: VAPID_KEY });
        if (!token) return;

        // Guard: skip if user doc doesn't exist yet
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (!userDoc.exists()) return;

        const existingTokens = userDoc.data().fcmTokens || [];
        if (!existingTokens.includes(token)) {
          await updateDoc(doc(db, 'users', user.uid), {
            fcmTokens: [...existingTokens, token],
            notificationsEnabled: true,
          });
        }

        onMessage(messaging, (payload) => {
          const { title, body } = payload.notification || {};
          if (title) {
            new Notification(title, {
              body: body || '',
              icon: '/torch_logo.png',
            });
          }
        });

      } catch (err) {
        console.error('FCM setup failed:', err);
      }
    };

    const timer = setTimeout(setupFCM, 2000);
    return () => clearTimeout(timer);
  }, []);
}
